import React, { useContext } from "react"
import TextField from '@material-ui/core/TextField'
import FormControl  from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'

import RenderError from '../render-error'

import MembershipContext from '../../context/membership'
import { getSS } from '../../helpers'

interface YourDetailsProps {
  [key: string]: any
}

const YourDetails: React.FC<YourDetailsProps> = (props:any) => {

  const membershipForm = useContext(MembershipContext)
  const membership_form = (window as any).KEW.collections.membership_form[0]
  const homepage = getSS('membership')
  const jointMembership = homepage.selected_membership.value === 'jointfriend' || homepage.selected_membership.value === 'jointfamfriend' || homepage.selected_membership.value === 'wakehurst_jointfriend' || homepage.selected_membership.value === 'wakehurst_jointfamfriend' || homepage.selected_membership.value === 'jointfriendplus' || homepage.selected_membership.value === 'jointfamfriendplus';

  function handleBlur(field: string, val: string) {
    if (field === 'existing_membership_number') {
      val = val.replace(/m/g, 'M').replace(/w/, 'W')
      props.setFieldValue(field, val.trim())
    }
  }

  return (
    <>
      <div className="row">
        <div className="your-details clearfix box">
          { membershipForm.preSelectedMembership &&
            <div>
              <div className="medium-12 columns">
                <h2>Your details</h2>
                <p>Please fill in the details below to complete your sign-up for a{homepage.selected_membership.value === 'indfriend' &&<span>n</span>} <strong>{homepage.selected_membership.title}</strong> membership.</p>
              </div>
            </div>
          }
          { !membershipForm.preSelectedMembership &&
            <div className="not-preselected clearfix">
              <div className="medium-6 columns">
                { membership_form.form_type !== 'upgrade' &&
                  <p>Please fill in the details below to complete your sign-up for a{homepage.selected_membership.value === 'indfriend' &&<span>n</span>} <strong>{homepage.selected_membership.title}</strong> membership.</p>
                }
                { membership_form.form_type === 'upgrade' &&
                  <p>Please fill in the details below to complete your upgrade from <strong>{homepage.selected_membership.upgrade_from}</strong> membership to <strong>{homepage.selected_membership.title}</strong> membership.</p>
                }
              </div>
              <div className="medium-6 columns">
                <div className="membership-type">
                  <p className="type">{homepage.selected_membership.title} membership</p>
                  <p>{homepage.selected_membership.description}</p>
                </div>
              </div>
            </div>
          }
          <fieldset className="clearfix row">
            <legend>Your details</legend>
            <div className="medium-6 columns">
              <div className="input-container select">
                <FormControl>
                  <InputLabel htmlFor="title">Title</InputLabel>
                  <Select
                    variant="outlined"
                    name="salutation"
                    id="m-title"
                    autoComplete="honorific-prefix"
                    inputProps={{
                      "aria-describedby": "m-title_error"
                    }}
                    error={props.errors.salutation ? true : false}
                    value={props.values.salutation || ""}
                    onChange={props.handleChange}>
                    {
                      Object.entries(props.titles).map((title:any, index:any) => {
                        return (
                          <MenuItem key={index} value={title[0]}>{title[1]}</MenuItem>
                        )
                      })
                    }
                  </Select>
                </FormControl>
                <RenderError name="salutation" id="m-title_error" {...props} />
              </div>
              <div className="input-container">
                <TextField
                  type="text"
                  variant="outlined"
                  id="m-first-name"
                  name="first_name"
                  label="First name"
                  autoComplete="given-name"
                  inputProps={{
                    "aria-describedby": "m-first-name_error"
                  }}
                  error={props.errors.first_name ? true : false}
                  value={props.values.first_name}
                  onChange={props.handleChange} />
                <RenderError name="first_name" id="m-first-name_error" {...props} />
              </div>
              <div className="input-container">
                <TextField
                  type="text"
                  variant="outlined"
                  id="m-last-name"
                  name="last_name"
                  label="Last name"
                  autoComplete="family-name"
                  inputProps={{
                    "aria-describedby": "m-last-name_error"
                  }}
                  error={props.errors.last_name ? true : false}
                  value={props.values.last_name}
                  onChange={props.handleChange} />
                <RenderError name="last_name" id="m-last-name_error" {...props} />
              </div>
            </div>
            <div className="medium-6 columns">
              <div className="input-container">
                <TextField
                  type="text"
                  variant="outlined"
                  id="m-email-address"
                  name="email"
                  label="Email address"
                  autoComplete="email"
                  inputProps={{
                    "aria-describedby": "m-email-address_error"
                  }}
                  error={props.errors.email ? true : false}
                  value={props.values.email}
                  onChange={props.handleChange} />
                <RenderError name="email" id="m-email-address_error" {...props} />
              </div>
              <div className="input-container">
              <div className="input-container">
                <TextField
                  type="tel"
                  variant="outlined"
                  id="m-phone-number"
                  name="phone"
                  label="Phone number (optional)"
                  autoComplete="tel"
                  inputProps={{
                    "aria-describedby": "m-phone-number_error"
                  }}
                  error={props.errors.phone ? true : false}
                  value={props.values.phone}
                  onChange={props.handleChange} />
                <RenderError name="phone" id="m-phone-number_error" {...props} />
              </div>
              { (membership_form.form_type === 'renewal' || membership_form.form_type === 'upgrade') &&
                <div className="input-container" id="existing-membership-number">
                  <TextField
                    type="text"
                    variant="outlined"
                    id="m-existing-membership-number"
                    name="existing_membership_number"
                    label="Membership number"
                    inputProps={{
                      "aria-describedby": "m-existing-membership-number_error"
                    }}
                    error={props.errors.existing_membership_number ? true : false}
                    value={props.values.existing_membership_number}
                    onChange={props.handleChange}
                    onBlur={(e) => handleBlur('existing_membership_number', e.target.value)} />
                  <RenderError name="existing_membership_number" id="m-existing-membership-number_error" {...props} />
                  { membership_form.form_type === 'renewal' &&
                    <p className="info clear">Please provide your current or recently expired membership number here. You can find your membership number on your membership card, or on any recent correspondence from us.</p>
                  }
                  { membership_form.form_type === 'upgrade' &&
                    <p className="info clear">Please provide your current membership number here. You can find your number on your membership card, or on any recent correspondence from us.</p>
                  }
                </div>
              }

            </div>
            <div className="large-12 columns"></div>
            {/* .medium-6.columns ng-if="appeal.membership_number_active"
              md-input-container.md-block flex-gt-sm=
                label for="m-membership-number" {{membership.fieldLabel('membership_number')}}
                input#m-membership-number ng-model="membership.membership_number" name="membership_membership_number" sepia-validate= tabindex="0"
                span.description {{appeal.membership_number_explanatory_copy}}
                span.error ng-if="showErrors && membershipForm.membership_membership_number.$error.sepiaValidation" {{sepiaFormErrors['membership.membership_number']}}
            .medium-6.columns ng-if="appeal.membership_number_active"
              md-input-container.md-block flex-gt-sm=
                p.info {{appeal.membership_help_copy}} */}
            </div>
          </fieldset>
        </div>
        { jointMembership &&
          <div className="second-adult-details clearfix box">
            <div className="medium-12 columns">
              <h2>Joint member's details</h2>
            </div>
            <div className="medium-6 columns">
              <div className="input-container select">
                <FormControl>
                  <InputLabel htmlFor="title">Title</InputLabel>
                  <Select
                    variant="outlined"
                    name="second_named_adult_salutation"
                    id="title"
                    inputProps={{
                      "aria-describedby": "title_error"
                    }}
                    error={props.errors.second_named_adult_salutation ? true : false}
                    value={props.values.second_named_adult_salutation || ''}
                    onChange={props.handleChange}>
                    {
                      Object.entries(props.titles).map((title:any, index:any) => {
                        return (
                          <MenuItem key={index} value={title[0]}>{title[1]}</MenuItem>
                        )
                      })
                    }
                  </Select>
                </FormControl>
                <RenderError name="second_named_adult_salutation" id="title_error" {...props} />
              </div>
              <div className="input-container">
                <TextField
                  type="text"
                  variant="outlined"
                  id="first-name"
                  name="second_named_adult_first_name"
                  label="First name"
                  inputProps={{
                    "aria-describedby": "first-name_error"
                  }}
                  error={props.errors.second_named_adult_first_name ? true : false}
                  value={props.values.second_named_adult_first_name}
                  onChange={props.handleChange} />
                <RenderError name="second_named_adult_first_name" id="first-name_error" {...props} />
              </div>
              <div className="input-container">
                <TextField
                  type="text"
                  variant="outlined"
                  id="last-name"
                  name="second_named_adult_last_name"
                  label="Last name"
                  inputProps={{
                    "aria-describedby": "last-name_error"
                  }}
                  error={props.errors.second_named_adult_last_name ? true : false}
                  value={props.values.second_named_adult_last_name}
                  onChange={props.handleChange} />
                <RenderError name="second_named_adult_last_name" id="last-name_error" {...props} />
              </div>
            </div>
            <div className="medium-6 columns">
              <div className="input-container">
                <TextField
                  type="text"
                  variant="outlined"
                  id="email-address"
                  name="second_named_adult_email"
                  label="Email address"
                  inputProps={{
                    "aria-describedby": "email-address_error"
                  }}
                  error={props.errors.second_named_adult_email ? true : false}
                  value={props.values.second_named_adult_email}
                  onChange={props.handleChange} />
                <RenderError name="second_named_adult_email" id="email-address_error" {...props} />
              </div>
              <div className="input-container">
                <TextField
                  type="tel"
                  variant="outlined"
                  id="joint-member-phone-number"
                  name="second_named_adult_phone"
                  label="Phone number (optional)"
                  inputProps={{
                    "aria-describedby": "joint-member-phone-number_error"
                  }}
                  error={props.errors.second_named_adult_phone ? true : false}
                  value={props.values.second_named_adult_phone}
                  onChange={props.handleChange} />
                <RenderError name="second_named_adult_phone" id="joint-member-phone-number_error" {...props} />
              </div>
            </div>
          </div>
        }
      </div>
    </>
  );
};

export default YourDetails;